import { apiPaths, getApiPath, httpStatus } from '../../../constants'
import { Api } from '../../../middlewares'
import { Logger, LoggerTypes } from '../../../utils'

// -- GET
export const GET_SCENARIO_PARAMETERS_SUCCESS = 'GET_SCENARIO_PARAMETERS_SUCCESS'
export const GET_SCENARIO_PARAMETERS_FAILURE = 'GET_SCENARIO_PARAMETERS_FAILURE'

// -- CREATE
export const CREATE_SCENARIO_PARAMETER_SUCCESS = 'CREATE_SCENARIO_PARAMETER_SUCCESS'
export const CREATE_SCENARIO_PARAMETER_FAILURE = 'CREATE_SCENARIO_PARAMETER_FAILURE'

// -- UPDATE
export const UPDATE_SCENARIO_PARAMETER_SUCCESS = 'UPDATE_SCENARIO_PARAMETER_SUCCESS'
export const UPDATE_SCENARIO_PARAMETER_FAILURE = 'UPDATE_SCENARIO_PARAMETER_FAILURE'

// -- DELETE
export const DELETE_SCENARIO_PARAMETER_SUCCESS = 'DELETE_SCENARIO_PARAMETER_SUCCESS'
export const DELETE_SCENARIO_PARAMETER_FAILURE = 'DELETE_SCENARIO_PARAMETER_FAILURE'

// -- SEARCH
export const SEARCH_SCENARIO_PARAMETERS = 'SEARCH_SCENARIO_PARAMETERS'

// -----------------------------------------------------------------------------

/**
 * SEARCH for a scenario parameter attribute based on its name.
 *
 * @param {string} terms Text to be searched within the scenario's parameter.
 * @returns {Promise<array<object>>}
 */
export const searchScenarioParameters = (terms) => async (dispatch) => {
  dispatch({
    type: SEARCH_SCENARIO_PARAMETERS,
    data: terms
  })
}

/**
 * GET the list of all the parameters that belong to a specific scenario.
 *
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {Promise<array<object>>}
 */
export const getScenarioParameters = (pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_PARAMETER_LIST, { pid, sid })
  const api = new Api(path)
  const result = await api.get()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] parametersActions.getScenarioParameters()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: GET_SCENARIO_PARAMETERS_SUCCESS,
      data: result.data.items || []
    })
  }
  return dispatch({
    type: GET_SCENARIO_PARAMETERS_FAILURE,
    data: result.data
  })
}

/**
 * CREATE a scenario parameter attribute.
 *
 * @param {object} newParameter New parameter to be created.
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {object}
 */
export const createScenarioParameter = (newParameter, pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_PARAMETER_CREATE, { pid, sid })
  const api = new Api(path)
  const result = await api.create(newParameter)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] parametersActions.createScenarioParameter()', {
    path,
    newParameter,
    result
  })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CREATE_SCENARIO_PARAMETER_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: CREATE_SCENARIO_PARAMETER_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific scenario parameter attribute.
 *
 * @param {object} newParameter Parameter object that will replace the previous one.
 * @param {uuid} mid Scenario's parameter ID.
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {Promise<object>}
 */
export const updateScenarioParameter = (newParameter, mid, pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_PARAMETER_UPDATE, { pid, sid, mid })
  const api = new Api(path)
  const result = await api.update(newParameter)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] parametersActions.updateScenarioParameter()', {
    newParameter,
    path,
    result
  })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_SCENARIO_PARAMETER_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_SCENARIO_PARAMETER_FAILURE,
    data: result.data
  })
}

/**
 * DELETE a specific scenario parameter attribute.
 *
 * @param {uuid} mid Scenario's parameter ID.
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {Promise<object>}
 */
export const deleteScenarioParameter = (mid, pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_PARAMETER_DELETE, { pid, sid, mid })
  const api = new Api(path)
  const result = await api.delete()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] parametersActions.deleteScenarioParameter()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: DELETE_SCENARIO_PARAMETER_SUCCESS,
      data: mid
    })
  }
  return dispatch({
    type: DELETE_SCENARIO_PARAMETER_FAILURE,
    data: result.data
  })
}
